/**
 * Les mesures Amplitude de l'accueil de l'élève, sous les noms de l'ancien accueil : les séries
 * continuent à l'allumage, et l'avant / après se compare (Amplitude plafonne les types : un nom
 * nouveau ne serait pas ingéré).
 *
 *  - la mission de Sam : `sam.banner.shown` et `sam.banner.clicked`, comme le bandeau de Sam
 *    (`NextLiveSessionBanner.js:155, 194`) ;
 *  - la boîte « pas le jour du live » : l'ancienne (`showLiveNotTodayDialog`, `<DialogM>`) mesure
 *    son bouton par `dialogButtonEvent` (`dialog.button.clicked`, le titre et le bouton en
 *    propriétés) : l'événement se compose ici sur le titre de l'ancienne boîte. Sa croix (`button`
 *    `times`) n'a pas d'équivalent :
 *    la boîte du design system n'a que son « OK », et le voile, Échap ou le retour d'Android qui la
 *    congédient ne mesurent rien (une boîte ne se mesure que sur ses boutons).
 *
 * La boîte du paiement en attente (`PaymentBlockedModal.js`) ne mesurait rien : rien ici non plus.
 * Les écrans vus (`screen.viewed.home`…) partent toujours de la navigation (`App.js`), sur les noms
 * d'onglets d'aujourd'hui.
 */
import * as amplitude from "@amplitude/analytics-react-native"

import { dialogButtonEvent } from "../../../hooks/trackDialogButton"
import { track } from "../../../hooks/trackEvent"

/** Le titre de l'ancienne boîte (`showLiveNotTodayDialog.js`), dont la mesure garde les valeurs. */
const NOT_TODAY_TITLE = "Le live n'est accessible que le jour-même"

export const HOME_EVENTS = {
    samBannerShown: "sam.banner.shown",
    samBannerClicked: "sam.banner.clicked",
    notTodayOk: dialogButtonEvent(NOT_TODAY_TITLE, "OK"),
} as const

export function trackSamBannerShown(prescribedCount: number) {
    amplitude.track(HOME_EVENTS.samBannerShown, { prescribed_count: prescribedCount })
}

export function trackSamBannerClicked(prescribedCount: number | undefined, targetActivityId: string | number) {
    amplitude.track(HOME_EVENTS.samBannerClicked, {
        prescribed_count: prescribedCount,
        target_activity_id: targetActivityId,
    })
}

/** La boîte « pas le jour du live » fermée : son « OK » se mesure ; congédiée, rien. */
export function trackNotTodayClosed(how: "button" | "dismiss" | undefined) {
    if (how === "button") track(HOME_EVENTS.notTodayOk)
}
